import React, { useCallback, useState } from 'react';
import { CollapsedEventNameWrapper, EventWrapper } from '../styled';
import Icon, { DownOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Tag, Tooltip, Radio } from 'antd';
import DeleteSvg from '@icons/event-management/delete-blue.svg';
import CustomMultiSelect from './CustomMultiSelect';

const DimensionItem = ({
  canEdit,
  onDelete,
  dimensionDetails,
  handleEventSelection,
  selectedMappedEvents,
  propagationMethod = 'first',
  onPropagationMethodChange,
}) => {
  const [isExpanded, setExpanded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const options =
    dimensionDetails?.mapped_event_names.map((eventName) => ({
      label: eventName,
      value: eventName,
    })) || [];
  const toggleExpanded = useCallback(() => {
    setExpanded(!isExpanded);
  }, [isExpanded]);

  return (
    <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <EventWrapper>
        <CollapsedEventNameWrapper onClick={toggleExpanded}>
          <div
            style={{
              textAlign: 'left',
              paddingRight: '5px',
              display: 'flex',
              flex: 1,
              alignItems: 'center',
            }}
          >
            {isExpanded ? (
              <DownOutlined style={{ color: 'rgb(0,0,0,0.45)' }} />
            ) : (
              <RightOutlined style={{ color: 'rgb(0,0,0,0.45)' }} />
            )}
            <strong style={{ paddingLeft: '8px', fontWeight: '500' }}>Dimension:</strong>
            <div
              style={{
                paddingLeft: '8px',
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              <span>{dimensionDetails?.display_name}</span>
            </div>
          </div>
          {canEdit && isHovered ? (
            <Tooltip title="Delete">
              <Button
                type={'text'}
                style={{ color: 'rgba(0, 0, 0, 0.45)' }}
                icon={<Icon component={DeleteSvg} style={{ fontSize: '12px' }} />}
                onClick={(e) => {
                  onDelete?.(dimensionDetails.id);
                  e.stopPropagation();
                }}
              />
            </Tooltip>
          ) : null}
        </CollapsedEventNameWrapper>
        {isExpanded && (
          <div style={{ padding: '12px', borderTop: '1px solid #f0f0f0' }}>
            <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ width: '100px' }}>Source Event</div>
              <CustomMultiSelect
                selectedIds={selectedMappedEvents}
                onChange={(selectedEvents) =>
                  handleEventSelection(dimensionDetails.id, selectedEvents)
                }
                options={options}
                placeholder="Select events where this value is captured"
                disabled={!canEdit}
              />
            </div>
            <div>
              {selectedMappedEvents.map((eventName) => (
                <Tag key={eventName} style={{ marginBottom: '4px' }}>
                  {eventName}
                </Tag>
              ))}
            </div>
            <div style={{ marginTop: '12px' }}>
              <div>Which value should be used when multiple exist?</div>
              <Radio.Group
                value={propagationMethod}
                onChange={(e) => onPropagationMethodChange?.(dimensionDetails.id, e.target.value)}
                size="small"
                disabled={!canEdit}
                style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
              >
                <Radio value="first">First observed value</Radio>
                <Radio value="last">Last observed value</Radio>
              </Radio.Group>
            </div>
            <div style={{ marginTop: '12px' }}></div>
          </div>
        )}
      </EventWrapper>
    </div>
  );
};

export default DimensionItem;
